﻿import { Container, Spinner } from 'reactstrap';
import useTheme from '../../hooks/useTheme';

export default function DataLoader() {
    const theme = useTheme();
    return (
        <Container fluid>
            <div id="data-loader" className="container-fluid text-center my-5 py-3">
                <div className="mb-2 p-2">
                    <Spinner color="primary" />
                </div>
                <h1 className={"display-5 fw-bold px-2 mt-2 mb-0 ".concat(theme === 'dark-mode' ? "text-light" : undefined)}>Loading <span className="text-primary">.</span></h1>
                <p className={"fs-3 px-2 ".concat(theme === 'dark-mode' ? "text-light" : undefined)}>Just a moment. We're getting things ready for you.</p>
            </div>
        </Container>
    );
}